import React from "react";
import { HorizontalBar } from "react-chartjs-2";
import { horizontalBar } from "./_commonSharedChartOptions";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  WidgetLoading,
  WidgetNoDataToDisplay,
  WidgetServerError
} from "../../../../components/DashboardWidget/WidgetCommon";
import { uncompletedRequestsByUserHeader } from "./_detailsTableHeaders";
import { uncompletedRequestsByUserDataPreview } from "./_previewData";

const widgetProps = {
  Chart: "UNCOMPLETED_REQUESTS_IN_TOTAL_BY_USER",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

const widgetDetails = {
  Chart: "UNCOMPLETED_REQUESTS_IN_TOTAL_BY_USER_USER_DETAIL",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class UncompletedRequestsByUserContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, updateDetailData, toggleRightSidebar, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">Uncompleted Requests - User</div>
        <div className="widgetTitleDescription">Number of uncompleted requests by user - click for details</div>
        <div className="widgetBody">
          {widgetData /*&& !this.state.loading*/ ? (
            widgetData.code !== 200 || draggable ? (
              <WidgetServerError draggable={draggable} />
            ) : widgetData.chart_data.data_dict.Items.length === 0 || draggable ? (
              <WidgetNoDataToDisplay draggable={draggable} />
            ) : (
              <HorizontalBar
                id={widgetDetails.Chart}
                data={{
                  labels: widgetData.chart_data.labels,
                  datasets: widgetData.chart_data.data_dict.Items
                }}
                options={_.extend({}, horizontalBar, {
                  hover: {
                    onHover: function(e) {
                      let point = this.getElementAtEvent(e);
                      if (point.length) e.target.style.cursor = "pointer";
                      else e.target.style.cursor = "default";
                    }
                  }
                })}
                onElementsClick={elems => {
                  if (elems[0]) {
                    this.getWidgetData(
                      _.extend({}, widgetDetails, {
                        username: widgetData.lookup_usernames[elems[0]._index]
                      })
                    );
                    toggleRightSidebar();

                    updateDetailData({
                      Chart: widgetDetails.Chart,
                      contentType: "table_data",
                      data: uncompletedRequestsByUserHeader
                    });
                  }
                }}
              />
            )
          ) : (
            <WidgetLoading />
          )}
        </div>
      </div>
    );
  }
}

export const UncompletedRequestsByUserPreview = () => {
  return (
    <div>
      <div className="widgetTitle">Uncompleted Requests - User</div>
      <div className="widgetBody">
        <HorizontalBar
          data={uncompletedRequestsByUserDataPreview}
          options={_.merge({}, horizontalBar, {
            legend: { display: false },
            scales: {
              yAxes: [
                {
                  ticks: {
                    fontSize: 5
                  }
                }
              ]
            },
            plugins: {
              datalabels: {
                font: {
                  size: 5
                }
              }
            }
          })}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard[widgetProps.Chart],
    dashboardDates: state.dashboard.widgetFromToDate,
    skill: state.skill
  };
}

export const UncompletedRequestsByUserContent = connect(
  mapStateToProps,
  undefined
)(UncompletedRequestsByUserContentClass);
